import { render, staticRenderFns } from "./yue.vue?vue&type=template&id=039b9784&scoped=true"
import script from "./yue.vue?vue&type=script&lang=js"
export * from "./yue.vue?vue&type=script&lang=js"
import style0 from "./yue.vue?vue&type=style&index=0&id=039b9784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039b9784",
  null
  
)

export default component.exports